import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListShippingRules from "../../../../components/@shipping/shipping_rules/ListShippingRules";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRulesPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListShippingRules
                routeType={routeType}
            />
        </SettingFrame>
    )
}       